/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { ColumnTexts, INDENT, StackView, Text } from '@veeam-vspc/components';

import { isEmpty } from 'core/utils';

export interface JobStatisticsValueTextProps {
    text: React.ReactNode;
}

export const JobStatisticsValueText: React.FC<JobStatisticsValueTextProps> = ({ text }) => (
    <StackView spaceLeft={INDENT.xl} spaceRight={INDENT.xl}>
        <Text>{!isEmpty(text) ? text : ColumnTexts.DashSymbol}</Text>
    </StackView>
);
